import React from "react";
import BaseOptions from "./BaseOptions";

/**
 * @class NormalFieldOptions
 * @extends BaseOptions
 * @description A component which contains a title and required field options
 */
export default class NormalFieldOptions extends BaseOptions {
  render() {
    return (
      <div>
        {this.renderTitle()}
        {this.renderRequiredOption()}
        {this.renderVisibilityOption()}
      </div>
    );
  }
}
